import React, { useState, useEffect } from 'react';
import { Row, Col, Button, Form, Card } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import moment from 'moment';

// components
import ProductDetail from './components/modal/ProductDetail';
import RawMaterialDetail from './components/modal/RawMaterialDetail';
import ProcessDetail from './components/modal/ProcessDetail';
import Month from './components/table/Month';
import Quater from './components/table/Quater';
import Half from './components/table/Half';
// function
import { getLoginInform } from 'function/login';
// global
import { useConfirmModalState } from 'global/confirmModalState';
// types
import { RESPONSE_CODE } from 'types/const';
// api
import { factory, category } from 'api/haccp/commonApi';
import { limitExcd, limitExcdDetail } from 'api/haccp/report/limitStandardApi';

/*
 * 보고서 > 한계기준이탈현황
 */
const List = () => {
  /* recoil */
  const { setConfirmModal } = useConfirmModalState();

  /* state */
  const [adminYn, setAdminYn] = useState(null); // Y: 관리자, N: 이천,군산 담당자
  const [isPrdtModalShow, setIsPrdtModalShow] = useState(false); // 제품상세 Modal
  const [isRawMtrlModalShow, setIsRawMtrlModalShow] = useState(false); // 원료상세 Modal
  const [isProcModalShow, setIsProcModalShow] = useState(false); // 공정상세 Modal
  const [isSettingCompleted, setIsSettingCompleted] = useState(false); // 설정완료 여부
  const [factoryOptions, setFactoryOptions] = useState(null);
  const [categoryOptions, setCategoryOptions] = useState(null);
  const [cycleOptions] = useState([
    { key: 'mt', value: '월' },
    { key: 'qt', value: '분기' },
    { key: 'hf', value: '반기' }
  ]);

  // 한계기준 이탈현황 Data
  const [data, setData] = useState([]);
  // 건수 Sum Data
  const [totalSumData, setTotalSumData] = useState([]);
  // 한계기준 상세 Modal Data
  const [detailModalData, setDetailModalData] = useState({
    itemNm: '', // 원료명
    cycle: '', // 주기(월,분기,반기)
    inOutType: '', // 내부,외부
    list: [] // 상세내역 Data
  });

  /* 조회조건 */
  const [pltCd, setPltCd] = useState(''); // 공장
  const [ctgryGrpCd, setCtgryGrpCd] = useState(''); // 분류: 제품,공정,원료
  const [year, setYear] = useState(new Date()); // 조회연도
  const [cycleCd, setCycleCd] = useState(''); // 주기선택
  const [searchParams, setSearchParams] = useState({});

  /* event */

  /* 설정완료 */
  const onSetting = () => {
    if (pltCd === '' || ctgryGrpCd === '' || cycleCd === '') {
      setConfirmModal({
        isOpen: true,
        title: '확인',
        message: '공장, 분류, 주기 선택해주세요.',
        isConfirmBtn: true
      });
      return;
    }

    setSearchParams({
      ...searchParams,
      pltCd: pltCd,
      ctgryGrpCd: ctgryGrpCd,
      year: Number(moment(year).format('YYYY')),
      cycleCd: cycleCd
    });
  };

  /* 한계기준 이탈현황 Api */
  const onSettingRequest = async () => {
    setIsSettingCompleted(true);

    const response = await limitExcd(searchParams);

    const { code, list, message } = response || {};
    if (code !== RESPONSE_CODE.Success) {
      setConfirmModal({
        isOpen: true,
        title: '확인',
        message: message,
        isConfirmBtn: true
      });
      setData([]);
      setTotalSumData([]);

      return;
    }
    setData(list);
  };

  /**
   * 한계기준 이탈현황 상세 선택
   */
  const onDetailModal = async detailData => {
    const { itemCd, itemNm, detailType, cycleNum } = detailData || {};
    const { pltCd, ctgryGrpCd, cycleCd, year } = searchParams || {};

    const params = {
      pltCd: pltCd,
      ctgryGrpCd: ctgryGrpCd,
      year: year,
      itemCd: itemCd,
      detailType: detailType,
      cycleCd: cycleCd,
      cycleNum: cycleNum
    };

    const response = await limitExcdDetail(params);

    const { code, list, message } = response || {};

    if (code !== RESPONSE_CODE.Success) {
      setConfirmModal({
        isOpen: true,
        title: '확인',
        message: message,
        isConfirmBtn: true
      });
      return;
    }

    // 상세 모달 상단 Tilte
    const { inOutType, cycle } = titleConvert(detailType, cycleNum);

    setDetailModalData({
      ...detailModalData,
      itemNm: itemNm,
      cycle: cycle,
      inOutType: inOutType,
      list: list
    });

    /* 분류 선택에 따른 Modal Open */
    switch (ctgryGrpCd) {
      case 'prdt':
        setIsPrdtModalShow(true);
        break;
      case 'proc':
        setIsProcModalShow(true);
        break;
      case 'rwmtr':
        setIsRawMtrlModalShow(true);
        break;
    }
  };

  /* 상세내역 Modal Title Convert */
  const titleConvert = (detailType, cycleNum) => {
    // 내부, 외부
    let inOutType = '';
    switch (detailType) {
      case 'intc':
      case 'inex':
        inOutType = '내부';
        break;
      case 'outc':
      case 'ouex':
        inOutType = '외부';
        break;
    }

    // 월, 분기, 반기
    let cycle = '';
    switch (cycleCd) {
      case 'mt':
        cycle = `${cycleNum}월`;
        break;
      case 'qt':
        cycle = `${cycleNum}분기`;
        break;
      case 'hf':
        cycle = `${cycleNum === 1 ? '상' : '하'}반기`;
        break;
    }

    return {
      inOutType: inOutType,
      cycle: cycle
    };
  };

  const getSumByKey = (arr, objKey, key) => {
    return arr.reduce(
      (accumulator, current) => accumulator + Number(current[objKey][key]),
      0
    );
  };

  /* 공장목록 API */
  const factoryList = async () => {
    const response = await factory();

    const { code, list } = response || {};
    if (code !== RESPONSE_CODE.Success) return;

    setFactoryOptions(list);
  };

  /* 분류목록 API */
  const categoryList = async () => {
    // const response = await category();

    // const { code, list } = response || {};
    // if (code !== RESPONSE_CODE.Success) return;
    // setCategoryOptions(list);

    // SFSH TODO 공정카테고리 임시주석
    setCategoryOptions([
      { ctgryCd: 'prdt', ctgryNmKr: '제품', ctgryNmEn: 'product' },
      { ctgryCd: 'rwmtr', ctgryNmKr: '원료', ctgryNmEn: 'Raw Material' }
    ]);
  };

  /* 로그인 정보 */
  const loginInfo = () => {
    const { adminYn, pltCd } = getLoginInform();

    if (adminYn === 'Y') {
      setAdminYn(adminYn);
      return;
    }

    setPltCd(pltCd);
    setAdminYn(adminYn);
  };

  /* watch */
  useEffect(() => {
    // 공장 API 호출
    factoryList();
    // 분류 API 호출
    categoryList();
    // 로그인정보
    loginInfo();
  }, []);

  useEffect(() => {
    if (Object.keys(searchParams).length === 0) return;
    // 조회API 호출
    onSettingRequest();
  }, [searchParams]);

  useEffect(() => {
    const { cycleCd } = searchParams || {};
    if (data?.length === 0 || cycleCd === '') return;

    /**
     * cycleCd 따른 분류
     * cycleCount : 월: 12, 분기: 4, 반기: 2
     * key: mt: 월, qt: 분기, hf: 반기
     */
    let cycleCount = 0;
    let key = '';

    switch (cycleCd) {
      case 'mt':
        key = 'month';
        cycleCount = 12;
        break;
      case 'qt':
        key = 'quater';
        cycleCount = 4;
        break;
      case 'hf':
        key = 'half';
        cycleCount = 2;
        break;
    }

    /**
     * 한계기준 이탈 현황 상단 건수 합계
     * 월: 연총계, 1월...12월 각열 합 전체건수 합 / 이탈현황 합
     * 분기 연총계, 1분기...4분기 각열 전체건수 합 / 이탈현황 합
     * 반기 연총계, 상반기,하반기 각열 전체건수 합 / 이탈현황 합
     */
    let array = [];
    for (let i = 1; i <= cycleCount; i++) {
      let innerSum = 0;
      let outerSum = 0;
      let totalSum = 0;

      let innerExcdSum = 0;
      let outerExcdSum = 0;
      let totalExcdSum = 0;

      if (i === 1) {
        // 연총계 전체건수 합계
        innerSum = getSumByKey(data, 'insideTotalCnt', 'totalCnt');
        outerSum = getSumByKey(data, 'outsideTotalCnt', 'totalCnt');
        totalSum = innerSum + outerSum;

        // 연총계 이탈현황 합계
        innerExcdSum = getSumByKey(data, 'insideExcdCnt', 'totalCnt');
        outerExcdSum = getSumByKey(data, 'outsideExcdCnt', 'totalCnt');
        totalExcdSum = innerExcdSum + outerExcdSum;

        array.push({ totalSum: totalSum, totalExcdSum: totalExcdSum });
      }

      // 전체건수 합계
      innerSum = getSumByKey(data, 'insideTotalCnt', `${key}${i}`);
      outerSum = getSumByKey(data, 'outsideTotalCnt', `${key}${i}`);
      totalSum = innerSum + outerSum;

      // 이탈현황 합계
      innerExcdSum = getSumByKey(data, 'insideExcdCnt', `${key}${i}`);
      outerExcdSum = getSumByKey(data, 'outsideExcdCnt', `${key}${i}`);
      totalExcdSum = innerExcdSum + outerExcdSum;

      array.push({ totalSum: totalSum, totalExcdSum: totalExcdSum });
    }

    setTotalSumData(array);
  }, [data]);
  return (
    <>
      <Card>
        <Card.Header>
          <Row className="align-items-center g-2">
            <Col>
              <h5 className="mb-0">한계기준 이탈현황</h5>
            </Col>
          </Row>
        </Card.Header>
        <Card.Body className="pt-0">
          <Form.Group className="mb-3">
            <Row className="ms-0 me-0 mt-3">
              {/* 공장 선택 select-box */}
              <Col sm={2} className="ps-1 pe-1">
                <Form.Select
                  size="sm"
                  onChange={({ target: { value } }) => setPltCd(value)}
                  value={pltCd}
                  disabled={adminYn === 'N'}
                >
                  <option disabled value="">
                    공장선택
                  </option>
                  {factoryOptions?.map(option => (
                    <option key={option.pltCd} value={option.pltCd}>
                      {option.pltNmKo}
                    </option>
                  ))}
                </Form.Select>
              </Col>
              {/* 분류 Select Box*/}
              <Col sm={2} className="ps-1 pe-1">
                <Form.Select
                  required
                  size="sm"
                  onChange={({ target: { value } }) => setCtgryGrpCd(value)}
                  value={ctgryGrpCd}
                >
                  <option disabled value="">
                    분류선택
                  </option>
                  {categoryOptions?.map(option => (
                    <option key={option.ctgryCd} value={option.ctgryCd}>
                      {option.ctgryNmKr}
                    </option>
                  ))}
                </Form.Select>
              </Col>
              {/* 조회연도 */}
              <Col sm={2} className="ps-1 pe-1">
                <DatePicker
                  onKeyDown={e => {
                    e.preventDefault();
                  }}
                  locale="ko"
                  dateFormat="yyyy년"
                  className="form-control form-control-sm"
                  showYearPicker
                  onChange={e => setYear(e)}
                  selected={year}
                />
              </Col>
              {/* 주기 선택 select-box */}
              <Col sm={2} className="ps-1 pe-1">
                <Form.Select
                  size="sm"
                  onChange={({ target: { value } }) => setCycleCd(value)}
                  value={cycleCd}
                >
                  <option disabled value="">
                    주기 선택
                  </option>
                  {cycleOptions.map(option => (
                    <option key={option.key} value={option.key}>
                      {option.value}
                    </option>
                  ))}
                </Form.Select>
              </Col>
              <Col
                sm={`auto`}
                className="ps-1 pe-1 d-flex flex-row align-items-center"
              >
                <Button size="sm" onClick={onSetting}>
                  설정 완료
                </Button>
              </Col>
            </Row>
          </Form.Group>
          {/* 조회조건 선택 후 설정완료 버튼 선택*/}
          {isSettingCompleted && data?.length > 0 && (
            <>
              {/* 월 */}
              {searchParams.cycleCd === 'mt' && (
                <Month
                  year={year}
                  data={data}
                  totalSumData={totalSumData}
                  onDetailModal={onDetailModal}
                ></Month>
              )}
              {/* 분기 */}
              {searchParams.cycleCd === 'qt' && (
                <Quater
                  year={year}
                  data={data}
                  totalSumData={totalSumData}
                  onDetailModal={onDetailModal}
                ></Quater>
              )}
              {/* 반기 */}
              {searchParams.cycleCd === 'hf' && (
                <Half
                  year={year}
                  data={data}
                  totalSumData={totalSumData}
                  onDetailModal={onDetailModal}
                ></Half>
              )}
            </>
          )}
          {isSettingCompleted && data?.length === 0 && (
            <div className="border border-300 d-flex align-items-center align-items-center justify-content-center min-vh-25 fw-bold">
              한계기준 이탈현황 데이터가 존재하지 않습니다.
            </div>
          )}
          {/* 설정완료 전 default text*/}
          {!isSettingCompleted && (
            <div className="border border-300 d-flex align-items-center align-items-center justify-content-center min-vh-25 fw-bold">
              한계기준 이탈현황 조회조건을 선택해주세요.
            </div>
          )}
        </Card.Body>
      </Card>
      {/* 제품 */}
      {isPrdtModalShow && (
        <ProductDetail
          modalShow={isPrdtModalShow}
          setModalShow={setIsPrdtModalShow}
          detailModalData={detailModalData}
        ></ProductDetail>
      )}
      {/* 원료 */}
      {isRawMtrlModalShow && (
        <RawMaterialDetail
          modalShow={isRawMtrlModalShow}
          setModalShow={setIsRawMtrlModalShow}
          detailModalData={detailModalData}
        ></RawMaterialDetail>
      )}
      {/* 공정 */}
      {isProcModalShow && (
        <ProcessDetail
          modalShow={isProcModalShow}
          setModalShow={setIsProcModalShow}
          detailModalData={detailModalData}
        ></ProcessDetail>
      )}
    </>
  );
};

export default List;
